module.exports = __webpack_public_path__ + "img/hearts.1154643d.png";